/**
 * Metric icons — thin wrappers over the unified domain icon registry
 * (./domain/registry.tsx) so the ~7 existing call sites keep their imports.
 * The old ad-hoc drawings (mixed 64/24 viewBoxes, solid fills, a shower head
 * that clashed with the water-droplet utility) are gone: one 24×24 stroke
 * style everywhere, browsable at /design/icons.
 */
import DomainIcon from './domain/DomainIcon';

interface MetricIconProps {
  className?: string;
  /** Accessible name; pass undefined for decorative use. */
  title?: string;
}

export function BedroomIcon({ className, title = 'Bedrooms' }: MetricIconProps) {
  return <DomainIcon id="bedroom" className={className} title={title} />;
}

export function BathroomIcon({ className, title = 'Bathrooms' }: MetricIconProps) {
  return <DomainIcon id="bathroom" className={className} title={title} />;
}

export function AreaIcon({ className, title = 'Area' }: MetricIconProps) {
  return <DomainIcon id="area" className={className} title={title} />;
}

export function ParkingIcon({ className, title = 'Parking' }: MetricIconProps) {
  return <DomainIcon id="parking" className={className} title={title} />;
}

export function PricePerSqmIcon({ className, title = 'Price per square meter' }: MetricIconProps) {
  return <DomainIcon id="price-sqm" className={className} title={title} />;
}
